const style = document.createElement("style");
style.innerHTML = `
  .fund-short-name {
    font-size: 16px;
    margin-top: 8px;
  }
  .nav-info-container {
    background: #F5F5F5;
    color: #999999;
    padding: 16px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    font-size: 16px;
    font-weight: 500;
    position: relative;
  }
  .nav-mobile-info {
    display: block;
  } 
  .nav-laptop-info {
    display: none;
  } 
  .expand-group-ranking-icon {
    display: flex;
   }
  .group-ranking-laptop-container{
    display: none;
  }
  .tags-container {
    display: flex; 
    margin: 8px 0;
    font-size: 12px;
    white-space: nowrap;
    overflow-x: auto;
  }
  
  @media (min-width: 768px) {
    .nav-info-container {
        display: flex;
    }
    .nav-mobile-info {
        display: none;
    } 
    .nav-laptop-info {
        display: block;
        color: #666666;
        margin-right: 8px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        white-space: nowrap;
    } 
    .expand-group-ranking-icon {
        display: none;
    }
    .group-ranking-laptop-container{
        display: flex;
        font-size: 16px;
        border: 1px solid #F5F5F5;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 16px;
    }
    .tags-container {
      font-size: 14px;
    }
  }
  @media (min-width: 1024px) {
    .fund-short-name {
      font-size: 24px;
    }
    .info-container {
      display: flex;
      width: 80%;
    }
    .nav-info-container {
      width: 350px;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      border-top-right-radius: 0px;
    }
    .group-ranking-laptop-container{
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
      flex: 1 1 0%;
    }
    .tags-container {
      margin: 8px 0 16px 0;
    }
  }
`;
document.head.appendChild(style);
let scriptId = document.getElementById("fundDetailInfoScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "MS32";

// 數字格式化
function NumFormatter(num, decimal) {
  this.value =
    num !== null && num !== undefined
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
        })
      : "--";

  this.addPercent = function () {
    this.value =
      num !== null && num !== undefined ? `${this.value}%` : this.value;
    return this;
  };

  this.addPrefix = function () {
    if (num > 0) this.value = `+${this.value}`;
    if (num < 0) this.value = `${this.value}`;
    return this;
  };
}

function numHandler(num, decimal = 2) {
  return new NumFormatter(num, decimal);
}

function formatComma(num, decimal) {
  return numHandler(num, decimal).value; //122,000
}

function formatPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().value; // 12.55%
}

function formatReturn(num, decimal) {
  return numHandler(num, decimal).addPrefix().value; // +122,000
}

function formatReturnPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().addPrefix().value; //+12.55%
}

function numTextColor(num) {
  if (num !== null && num !== undefined) {
    return num > 0
      ? "text-red-500"
      : num < 0
      ? "text-green-500"
      : "text-gray-500";
  } else {
    return "text-gray-800";
  }
}

function generateTagsList(data) {
  let tags = [];
  if (data.majorFund) {
    tags.push({
      value: "主基金",
      style: "background: #EBF4FE; color: #3491FA;",
    });
  }

  if (data.exchangeInTradable) {
    tags.push({
      value: "可交換",
      style: "background: #E6F9F9; color: #0EB9B5;",
    });
  }

  if (data.fundNameCategory === "ETF及指數") {
    tags.push({
      value: "持有ETF",
      style: "background: #E6F9F9; color: #0EB9B5;",
    });
  }

  if (data.tags && data.tags.length !== 0) {
    tags.push(
      ...data.tags.map((tag) => ({
        value: tag,
        style: "background: #E6F9F9; color: #0EB9B5",
      }))
    );
  }
  if (tags.length) {
    const fundTags = document.getElementById("fundTags");
    fundTags.innerHTML = "";
    tags.slice(0, 3).forEach((item) => {
      const tagDiv = document.createElement("div");

      // 設定 class
      tagDiv.style = `display: inline-block; border-radius: 4px; padding: 2px 4px; margin-right: 8px; font-weight: 500; ${item.style}`;

      // 設定內容
      tagDiv.textContent = item.value;

      // 插入到容器
      fundTags.appendChild(tagDiv);
    });
  }
}

function generatePortfolioList(data) {
  let tags = [];
  if (data.portfolio && data.portfolio.length) {
    tags.push(
      ...data.portfolio.map((tag) => ({
        value: tag.name,
        style:
          "color: #666666; background: #EBEBEB; padding: 2px 8px; border-radius: 50px; font-weight: 500;",
      }))
    );
  }
  if (tags.length) {
    const fundTags = document.getElementById("fundPortfolio");
    fundTags.innerHTML = "";
    tags.slice(0, 3).forEach((item) => {
      const tagDiv = document.createElement("div");

      // 設定 class
      tagDiv.style = `display: inline-block; margin-right: 8px; ${item.style}`;

      // 設定內容
      tagDiv.textContent = item.value;

      // 插入到容器
      fundTags.appendChild(tagDiv);
    });
  }
}
/* eslint-disable-next-line no-unused-vars */
function openGroupRanking() {
  const modal = document.getElementById("groupRankingModal");
  modal.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); z-index: 1000; justify-content: center; align-items: center;";
  modal.innerHTML = `
        <div style="background: white; width: 100%; position: absolute; bottom: 0;">
          <div style="font-size: 20px; font-weight: 700; color: #333333; border-bottom: 1px solid #EBEBEB; text-align: center; padding: 16px; position: relative;">
              基金類組績效
              <div style="width: 28px; height: 28px; display: flex; justify-content: center; align-items: center; cursor: pointer; position: absolute; right: 16px; top: 16px;" class="close-group-ranking-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" width="26px" height="26px"><path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"/></svg>
              </div>
          </div>
          <div style="padding: 16px; font-size: 16px;">
              <div style="color: #999999; margin-bottom: 16px;">${
                data.fundShortName
              }</div>  
              <div style="color: #333333; margin-bottom: 8px; font-weight: 500;">近1年報酬率統計</div>
              <div style="font-size: 14px; background: #F5F5F5; border-radius: 4px; padding: 0 16px;">
                  <div style="display: flex; justify-content: space-between; color: #666666; font-weight: 700; padding: 4px 0px; flex-shrink: 0">
                      <div>近一年績效</div>
                      <div style="font-weight: 400" class="${numTextColor(
                        data.oneYearGroupRanking &&
                          data.oneYearGroupRanking.rateOfReturn
                      )}">${formatReturnPercent(
    data.oneYearGroupRanking && data.oneYearGroupRanking.rateOfReturn
  )}</div>
                  </div>
                    <div style="display: flex; justify-content: space-between; color: #666666; font-weight: 700; padding: 4px 0px; flex-shrink: 0">
                      <div>同類最佳績效</div>
                      <div style="font-weight: 400" class="${numTextColor(
                        data.oneYearGroupRanking &&
                          data.oneYearGroupRanking.firstRateOfReturn
                      )}">${formatReturnPercent(
    data.oneYearGroupRanking && data.oneYearGroupRanking.firstRateOfReturn
  )}</div>
                  </div>
                  <div style="display: flex; justify-content: space-between; color: #666666; font-weight: 700; padding: 4px 0px; flex-shrink: 0">
                      <div >同類績效排名</div>
                      <div style="font-weight: 400;">
                          <span style="padding-right: 4px;">領先 ${formatPercent(
                            data.oneYearGroupRanking &&
                              data.oneYearGroupRanking.peerLeadingRatio
                          )}</span>
                          <span style="padding-left: 8px; border-left: 1px #EBEBEB solid"><span style="font-weight: 700">${formatComma(
                            data.oneYearGroupRanking &&
                              data.oneYearGroupRanking.ranking,
                            0
                          )}</span>/${formatComma(
    data.oneYearGroupRanking && data.oneYearGroupRanking.numberOfSamples,
    0
  )}</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    `;
  document.body.appendChild(modal);

  const closeBtn = modal.querySelector(".close-group-ranking-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", closeGroupRanking);
  }
}
/* eslint-disable-next-line no-unused-vars */
function closeGroupRanking() {
  const modal = document.getElementById("groupRankingModal");
  modal.style.display = "none";
}
/* eslint-disable-next-line no-unused-vars */
function openRankingGuide() {
  const modal = document.getElementById("rankingGuideModal");
  modal.style.cssText =
    "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); z-index: 1000; display: flex; justify-content: center; align-items: center;";
  modal.innerHTML = `
      <div style="background: white; width: 100%; max-width: 400px; padding: 16px; border-radius: 8px;">
        <div style="font-size: 18px; font-weight: 700; color: #333333; text-align: center; padding: 16px; position: relative;">
          同類最佳績效
          <div style="width: 28px; height: 28px; display: flex; justify-content: center; align-items: center; cursor: pointer; position: absolute; right: 0px; top: 0px; color: #333333; cursor: pointer;" class="close-ranking-guide-btn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" width="20px" height="20px"><path fill="currentColor" d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"/></svg>
          </div>
        </div>
        <div style="font-size:16px; padding: 8px; border: 1px solid #EBEBEB; border-radius: 8px; text-align: center;">
          「同類最佳」是指在同類基金中，過去一年報酬率表現最好的基金績效。
        </div>
        <div style="background: #FF9664; color: #FFFFFF; font-size: 18px; font-weight: bold; border-radius: 4px; margin-top: 16px; text-align: center; padding: 10px; cursor: pointer;" class="close-ranking-guide-btn">我知道了</div>
      </div>
  `;
  document.body.appendChild(modal);
  const closeBtns = document.querySelectorAll(".close-ranking-guide-btn");
  if (closeBtns) {
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", closeRankingGuide);
    });
  }
}
/* eslint-disable-next-line no-unused-vars */
function closeRankingGuide() {
  const modal = document.getElementById("rankingGuideModal");
  modal.style.display = "none";
}

// 為關閉按鈕添加 class
function setupEventListeners() {
  // 群組排名按鈕
  const expandIcon = document.querySelector(".expand-group-ranking-icon");
  if (expandIcon) {
    expandIcon.addEventListener("click", openGroupRanking);
  }

  // 關閉群組排名按鈕
  const closeGroupRankingBtn = document.querySelector(
    ".close-group-ranking-btn"
  );
  if (closeGroupRankingBtn) {
    closeGroupRankingBtn.addEventListener("click", closeGroupRanking);
  }

  // 開啟排名指南按鈕
  const openRankingGuideBtn = document.getElementById("openRankingGuide");
  if (openRankingGuideBtn) {
    openRankingGuideBtn.addEventListener("click", openRankingGuide);
  }

  // 關閉排名指南按鈕（包含「我知道了」按鈕）
  const closeRankingGuideBtns = document.querySelectorAll(
    ".close-ranking-guide-btn"
  );
  closeRankingGuideBtns.forEach((btn) => {
    btn.addEventListener("click", closeRankingGuide);
  });
}

let data;

function loadScript() {
  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}`;
  let url2 = `https://${window.location.host}/next/api/funds/detail/${mfxId}/realtime-numbers`;
  Promise.all([fetch(url), fetch(url2)])
    .then((responses) => {
      // 檢查兩個請求是否都成功
      if (!responses[0].ok || !responses[1].ok) {
        throw new Error("Network response was not ok");
      }

      // 返回兩個請求的 JSON 數據
      return Promise.all([responses[0].json(), responses[1].json()]);
    })
    .then(([data1, data2]) => {
      data = data1;
      //建立基本資料區域
      const fundInfo = document.createElement("div");

      //渲染基本資料
      fundInfo.innerHTML = `
       <div>
            <div style="font-size: 14px; color: #999999; font-weight: 500;">
                <span style="margin-right: 8px;">${
                  data1.fundArea
                }</span><span style="margin-right: 8px;">RR${
        data1.riskLevel
      }</span><span style="padding-left: 8px; border-left: 1px solid #EBEBEB;">${
        data1.generalIssuer
      }</span><span style="margin-left: 8px; padding: 4px 8px; background: #FFF3EE; border-radius: 4px; color: #FF9664;">可用${data1.currencyNameList.join(
        "、"
      )}買</span>
            </div>
           <div class="fund-short-name">
               <div style="color: #333333;">${data1.fundShortName}${
                  data1.warningWarning
                    ? `<span style="font-weight: 700">(${data1.warningWarning})</span>`
                    : ""
                }</div>
           </div>

           <div class="tags-container">
              <div id="fundTags"></div>
              <div id="fundPortfolio"></div>
           </div>

           <div class="info-container">
                <div class="nav-info-container">
                    <div>
                        <div class="nav-mobile-info">淨值<span style="margin-left: 4px">${
                          data2.navDate
                        }</span></div>
                        <div class="nav-laptop-info">淨值<span style="margin-left: 4px">(${
                          data2.navDate
                        })</span></div>
                        <div>
                            <span style="color: #666666; font-weight: 400;">${
                              data2.currency
                            }</span><span style="font-weight: 700; color: #333333; font-size: 20px; margin-left: 4px;">${formatComma(
        data2.nav,
        4
      )}</span>
                        </div>
                        
                    </div>
                    <div>
                        <div style="white-space: nowrap">漲跌
                            <span style="margin-left: 4px" class="${numTextColor(
                              data2.navChange
                            )}">${formatReturn(data2.navChange, 4)}</span>
                        </div>
                        <div style="padding-top: 4px; white-space: nowrap">
                        漲跌幅      
                            <span style="margin-left: 4px;" class="${numTextColor(
                              data2.navChangePercent
                            )}">${formatReturnPercent(
        data2.navChangePercent
      )}</span>
                        </div>
                    </div>
                    <div style="background: #FFFFFF; border-radius: 50%; width: 24px; height: 24px; justify-content: center; align-items: center; cursor: pointer; position: absolute; right: 16px; top: 10px;" class="expand-group-ranking-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14px" height="14px"><path d="M212.7 315.3L120 408l32.9 31c15.1 15.1 4.4 41-17 41h-112C10.7 480 0 469.3 0 456V344c0-21.4 25.8-32.1 40.9-17L72 360l92.7-92.7c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6zm22.6-118.6L328 104l-32.9-31C280 57.9 290.7 32 312 32h112C437.3 32 448 42.7 448 56v112c0 21.4-25.8 32.1-40.9 17L376 152l-92.7 92.7c-6.2 6.2-16.4 6.2-22.6 0l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6z"/></svg>
                    </div>
                </div>
                <div class="group-ranking-laptop-container">
                    <div style="color: #666666; margin-right: 16px; white-space: nowrap;">
                        <div style="font-size: 14px">近一年績效</div>
                        <div style="font-weight: 500; margin-top: 4px;" class="${numTextColor(
                          data1.oneYearGroupRanking &&
                            data1.oneYearGroupRanking.rateOfReturn
                        )}">${formatReturnPercent(
        data1.oneYearGroupRanking && data1.oneYearGroupRanking.rateOfReturn
      )}</div>
                    </div>
                    <div style="color: #666666; margin-right: 16px; white-space: nowrap;">
                        <div style="font-size: 14px; display: flex; align-items: center;">
                          同類最佳績效
                          <div id="openRankingGuide" style="color: #999999; display:flex; align-items: center; margin-left: 4px; cursor: pointer;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16"><path fill="currentColor" d="M256 8C119 8 8 119.1 8 256c0 137 111 248 248 248s248-111 248-248C504 119.1 393 8 256 8zm0 110c23.2 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.8-42 42-42zm56 254c0 6.6-5.4 12-12 12h-88c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h12v-64h-12c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h64c6.6 0 12 5.4 12 12v100h12c6.6 0 12 5.4 12 12v24z"/></svg>
                          </div>
                        </div>
                        <div style="font-weight: 500; margin-top: 4px;" class="${numTextColor(
                          data1.oneYearGroupRanking &&
                            data1.oneYearGroupRanking.firstRateOfReturn
                        )}">${formatReturnPercent(
        data1.oneYearGroupRanking && data1.oneYearGroupRanking.firstRateOfReturn
      )}</div>
                    </div>
                    <div style="color: #666666; white-space: nowrap;">
                        <div style="font-size: 14px">同類績效排名</div>
                        <div style="font-weight: 500; margin-top: 4px;">
                            <span style="padding-right: 4px;">領先 ${formatPercent(
                              data1.oneYearGroupRanking &&
                                data1.oneYearGroupRanking.peerLeadingRatio
                            )}</span>
                            <span style="font-size: 14px; padding-left: 8px; border-left: 1px #EBEBEB solid"><span style="font-weight: 700">${formatComma(
                              data1.oneYearGroupRanking &&
                                data1.oneYearGroupRanking.ranking,
                              0
                            )}</span>/${formatComma(
        data1.oneYearGroupRanking && data1.oneYearGroupRanking.numberOfSamples,
        0
      )}</span>
                        </div>
                    </div>
                </div>
           </div>

           <div id="groupRankingModal">
           </div>

            <div id="rankingGuideModal">
            </div>
       </div>
   `;

      const targetElement = document.getElementById("fundDetailInfoScript");

      targetElement.innerHTML = ""; // 清空原有內容
      targetElement.appendChild(fundInfo);
      generateTagsList(data1);
      generatePortfolioList(data1);
      setupEventListeners();
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}
loadScript();
